<template>
  <div>
    <el-drawer
      class="sideDrawer"
      :size="drawerSize"
      title="票据对应关系"
      destroy-on-close
      :visible.sync="dialogShow"
      :before-close="handleClose"
      :wrapperClosable="false"
      :close-on-press-escape="false"
      ><i class="iconfont icon-back-quanping iconFull" @click="drawerSize = '100%'" v-if="drawerSize == '70%'" />
      <i @click="drawerSize = '70%'" class="iconfont icon-back-tuichuquanping iconFull" v-else />
      <div class="form-content" style="padding: 20px">
        <el-form ref="form" label-width="150px">
          <el-table :data="receivablesData" border>
            <el-table-column width="100" property="data_id">
              <template slot-scope="scope">
                {{ dataIdList[scope.$index].label }}
              </template>
            </el-table-column>
            <el-table-column label="收款方式" property="valid_ids">
              <template slot-scope="scope">
                <el-select
                  v-model="scope.row.valid_ids"
                  placeholder="请选择"
                  multiple
                  :disabled="scope.$index === 2"
                  @change="changeValid(scope.$index, cwskfsList, 'valid_ids')"
                  style="width: 100%"
                >
                  <el-option v-for="item in transList(scope.$index, cwskfsList, 'valid_ids')" :key="item.key" :label="item.name" :value="item.key"> </el-option>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column property="paymentMethod" label="付款方式">
              <template slot-scope="scope">
                <el-select
                  v-model="scope.row.valid_names"
                  placeholder="请选择"
                  multiple
                  :disabled="scope.$index === 2"
                  style="width: 100%"
                  @change="changeValid(scope.$index, termsofpaymentList, 'valid_names')"
                >
                  <el-option v-for="item in transList(scope.$index, termsofpaymentList, 'valid_names')" :key="item.key" :label="item.name" :value="item.key">
                  </el-option>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column property="valid_type" label="票据分类">
              <template slot-scope="scope">
                <el-select
                  v-model="scope.row.valid_type"
                  placeholder="请选择"
                  multiple
                  style="width: 100%"
                  :disabled="scope.$index !== 1"
                  @change="changeValid(scope.$index, pjflList, 'valid_type')"
                >
                  <el-option v-for="item in transList(scope.$index, pjflList, 'valid_type')" :key="item.key" :label="item.name" :value="item.key"> </el-option>
                </el-select>
              </template>
            </el-table-column>
          </el-table>
        </el-form>
      </div>
      <div class="demo-drawer__footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" @click="handleSave" v-loading.fullscreen.lock="loading">确 定</el-button>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import utils from '@/utils.js'
export default {
  computed: {
    ...mapState({
      allDataDict: (state) => state.user.allDataDict,
      allEnumerate: (state) => state.user.allEnumerate
    })
  },
  data() {
    return {
      dialogShow: false,
      drawerSize: '70%',
      tenantId: '-1',
      loading: false,
      showPerson: false,
      noticeTimeShow: false,
      dimensionOptions: [],
      receivablesData: [],
      dataIdList: [],
      cwskfsList: [],
      termsofpaymentList: [],
      pjflList: []
    }
  },
  methods: {
    // 根据租户获取应收账款配置
    getReceivableCalculation() {
      let that = this
      that.dialogShow = true
      that.$http.get('${portal}/portal/data_switch_config/getByKey?typeKey=bill_management').then((resp) => {
        if (resp && resp.data) {
          that.$nextTick(() => {
            that.dataIdList = utils.getAllEnumerateAttr({
              isShowList: true,
              typeKey: 'BillRelationEnums',
              allData: that.allEnumerate
            })
            that.cwskfsList = utils.findDictList('cwskfs', that.allDataDict)
            that.termsofpaymentList = utils.findDictList('termsofpayment', that.allDataDict)
            that.pjflList = utils.findDictList('pjfl', that.allDataDict)
            this.receivablesData = resp.data.sub_data_switch_config_detail.map((items, index) => {
              items.valid_ids = items.valid_ids ? items.valid_ids.split(',') : []
              items.valid_names = items.valid_names ? items.valid_names.split(',') : []
              if (index === 0) items.valid_type = that.pjflList.map((items) => items.key)
              else items.valid_type = items.valid_type ? items.valid_type.split(',') : []
              return items
            })
          })
        }
      })
    },
    transList(index, data, key) {
      switch (index) {
        case 0:
          return data
        case 1:
          return data.filter((item) => this.receivablesData[0][key].includes(item.key))
        case 2:
          // 商业承兑的选择列表 非商业承兑
          const p = data.filter((item) => this.receivablesData[0][key].includes(item.key) && !this.receivablesData[1][key].includes(item.key))
          return p
      }
    },
    changeValid(index, data, key) {
      switch (index) {
        case 0:
          this.receivablesData[1][key] = []
          break
      }
      // 商业承兑的选择列表
      let pa = []
      data.forEach((item) => {
        if (this.receivablesData[0][key].includes(item.key) && !this.receivablesData[1][key].includes(item.key)) {
          pa.push(item.key)
        }
      })
      // 非商业承兑
      this.receivablesData[2][key] = pa
      this.$forceUpdate()
    },
    chooseCustom(name) {
      this.chooseName = name
    },
    //设置提醒时间
    showNoticeTime() {
      this.noticeTimeShow = true
    },
    closeNoticeTime(val) {
      if (val) {
        this.form.remind_time = val
      }
      this.noticeTimeShow = false
    },
    //变量选择
    setField(val, name) {
      let str = `{${val.label}:${val.value}}`
      this.form[name] = this.form[name].slice(0, this.blurIndex) + str + this.form[name].slice(this.blurIndex)
    },
    //重置必填项
    resetFields() {
      this.$refs.form && this.$refs.form.resetFields()
    },
    //统计数据
    statisticsDataChange() {},
    //关闭表单
    handleClose() {
      this.dialogShow = false
      this.$emit('close')
    },
    //提交表单
    handleSave() {
      let temp = this.receivablesData.map((items) => {
        items.valid_ids = items.valid_ids.join(',')
        items.valid_names = items.valid_names.join(',')
        items.valid_type = items.valid_type.join(',')
        return items
      })
      this.loading = true
      this.$http
        .put('${portal}/portal/data_switch_config_detail/updateList', temp)
        .then((res) => {
          if (res.data.state) {
            this.loading = false
            this.$message.info('保存成功！')
          } else {
            this.loading = false
            this.$message.error('保存失败！')
          }
          this.handleClose()
        })
        .catch(() => {
          this.loading = false
        })
    },
    //设置提醒人
    setPerson() {
      this.showPerson = true
    },
    //设置提醒人关闭
    close() {
      this.showPerson = false
    },
    onConfirm(val, sonTable, str) {
      this.form.reminder_members = str
      this.form.sub_business_reminder_member = sonTable
      this.showPerson = false
    }
  }
}
</script>

<style scoped></style>
